import { Pipe, PipeTransform } from '@angular/core';
import { StringFormattingService } from '../core/_services';

@Pipe({
  name: 'phone',
})
export class PhoneNumberPipe implements PipeTransform {
  constructor(private formatting: StringFormattingService) {}

  transform(unformattedPhoneNumber: string): string {
    return this.formatting.formatPhoneNumber(unformattedPhoneNumber);
  }
}
